import { http } from "@/lib/api";

export async function fetchCurrentCoachingDecision() {
  const { data } = await http.get("/athlete-coaching-decision/current");
  return data;
}
